import Vue from 'vue';
import axios from 'axios';
import store from 'store';
import { EnumErrorReportName, MessageStatus, RobotQuestionType, EnumErrorReportType } from 'constant';
import { isNumber, setAssociation, eventHub } from 'utils';
import { createHumanDialog } from 'service/HumanService';
import sendErrorReport from 'service/sendErrorReport';

/**
 * 获取入口信息/欢迎语
 */
export function fetchWelcomeMessage(parameters?: IVisitInfoParams) {
  return axios.post('api/portal/message/init', { type: 'Init', parameters: { ...parameters, fe: 'portal_pc' } });
}

/*
 * 发送消息同时展示返回消息列表
 * */
export function sendMessage(message: IMessage) {
  const { sendType, data } = message;
  const params = {
    type: sendType,
    parameters: data,
  };

  if (data.fromMessageId) {
    params.parameters.messageId = data.fromMessageId;
  }

  delete message.data.uuid; // 这俩字段后端用不到,删掉
  delete message.data.sendTime;

  Vue.set(message, 'status', MessageStatus.Loading);
  return new Promise((resolve, reject) => {
    axios
      .post('api/portal/message', params)
      .then((response) => {
        const { data: messageData, traceId } = response as unknown as Record<string, any>;
        message.status = MessageStatus.Success;
        if (!messageData) {
          sendErrorReport({
            errorType: EnumErrorReportType.Others,
            eventName: EnumErrorReportName.SendMessageNoResponse,
            parameters: params,
            memo: { data: messageData },
            traceId,
          });
          return store.dispatch('addMessage', {
            data: { content: '不好意思，小美正在学习中~' },
          });
        }
        const { isCreateChat, messageList, relationList, chatSceneTypeName: sceneTypeName } = messageData;
        if (isCreateChat) {
          const humanParams = sceneTypeName ? { sceneTypeName } : {};
          return createHumanDialog(humanParams);
        }
        if (messageList) {
          messageList.forEach((item) => {
            item.position = 'left';
          });
          store.dispatch('addMessage', messageList);
        } else {
          sendErrorReport({
            errorType: EnumErrorReportType.Others,
            eventName: EnumErrorReportName.SendMessageNoResponse,
            parameters: params,
            memo: { data: messageData },
            traceId,
          });
        }
        if (relationList) {
          eventHub.$emit(
            'update-association',
            setAssociation(messageData.relationList, { type: RobotQuestionType.ClickRelation })
          );
        }
        resolve(messageData);
        return null;
      })
      .catch((e: Error) => {
        message.status = MessageStatus.Fail;
        reject(e);
      });
  });
}

export function askKefu(message: IMessage) {
  delete message.data.uuid; // 这俩字段后端用不到,删掉
  delete message.data.sendTime;

  const params = message.data;

  Vue.set(message, 'status', MessageStatus.Loading);
  return new Promise((resolve, reject) => {
    axios
      .post('api/portal/session/message/chatText', params)
      .then(({ data }) => {
        if (data.code !== 200) {
          return Promise.reject(data);
        }
        message.status = MessageStatus.Success;
        if (!data) message.status = MessageStatus.Fail;
        resolve(data);
      })
      .catch((e: Error) => {
        message.status = MessageStatus.Fail;
        reject(e);
      });
  });
}

export function askRobot(params: any) {
  params.type = isNumber(params.type) ? params.type : RobotQuestionType.Default;
  return axios.post('api/portal/session/message/robotQuestion', params);
}

export function sendFileMessage(params: any) {
  return axios.post('api/portal/session/message/chatFile', params);
}

export function sendImageMessage(params: any) {
  return axios.post('api/portal/session/message/chatImage', params);
}

export function association(content) {
  return axios.post('api/portal/session/associationList', { content });
}

export function getHistoryMessages(lastMinMessageId, size = 10) {
  return axios.get('api/portal/session/message/history', { params: { lastMinMessageId, size } });
}

export function sendOrder(params) {
  return axios.post('api/portal/session/message/chatOrder', params);
}

export function sendFaqCategory(params) {
  return axios.post('api/portal/session/message/faqCategory', params);
}

export function chatOrderConfirm(params) {
  return axios.post('api/portal/session/message/chatOrderConfirm', params);
}

export function humanEvaluation(params) {
  return axios.post('api/portal/session/chatEvaluation', params);
}

export function evaluationReady() {
  return axios.post('api/portal/session/chatEvaluation/ready', { content: '我要评价' });
}

export function submitAnswer(params) {
  return axios.post('api/portal/session/evaluation', params);
}

export function setLike(params) {
  return axios.post('api/portal/session/like', params);
}

export function sendForm(params) {
  return axios.post('api/portal/session/message/chatForm', params);
}

export function pollingMapData(params: { orderId: string }) {
  return axios.post('api/portal/taskbot/polling/queryWaiMaiPkgTrace', params);
}
